<template>
  <el-dialog :title="$t('purchasing.payment')" custom-class="MyDialog" :visible.sync="isDialogVisiblePay" :close-on-click-modal="false"
    @close="closeProcure2Pay" width="920px">
    <div>
      <div class="purchase-info">
        <div class="textOne">
          <span>{{ $t('purchasing.orderNo') }}：{{ payData.orderNo }}</span>
          <span>{{ $t('purchasing.orderTime') }}：{{ payData.orderCreateTimeStr }}</span>
        </div>
        <div class="textTwo">
          <span>{{ $t('purchasing.purchaseQty') }}：{{ payData.buyNum }}{{ $t('purchasing.units') }}</span>
          <span>{{ $t('purchasing.orderAmount') }}：<span :style="{ color: 'red' }">{{
            payData.orderAmount
          }}</span>
          <span v-if="orderType == 'doubleOrder' || orderType == 'online'">（{{ $t('purchasing.freightIncluded') }}：{{ $i18n.locale === 'en-US' ? $crmCurrencySymbol() : '' }}{{ payData.freightAmount ? payData.freightAmount : 0  }}{{ $i18n.locale === 'en-US' ? '' : $crmCurrencySuffix() }}）</span>  
        </span>
          <span>{{ $t('purchasing.paidAmount') }}：<span :style="{ color: 'red' }">{{
            payData.receivedAmount
          }}</span></span>
        </div>
        <div class="textTwo">
           <span>{{ $t('purchasing.interestSpreadAmount') }}：<span :style="{ color: 'red' }">{{
            payData.interestSpreadAmount
          }}</span></span>
        </div>
      </div>
      <div class="pay-box" :class="{ 'pay-box-en': $i18n.locale === 'en-US' }">
        <el-form label-position="left" :label-width="$getColumnWidth(120, 180) + 'px'"  :model="formLabelAlign">
          <el-form-item v-if="orderType == 'doubleOrder'" :label="$t('purchasing.dualCampusNameLabel')">
            <span>{{ payData.dualCampusName }}</span>
          </el-form-item>
          <!-- 美版不展示 Voucher Bonus / 裂变抵扣，提交金额在 selectData 末尾强制为 0 -->
          <el-form-item v-if="$i18n.locale !== 'en-US'" :label="$t('purchasing.voucherBonusAccount')">
            <el-input v-model="formLabelAlign.voucherAccountPayMoney" @blur="countInputNum(1)"
              oninput="value=value.replace(/[^0-9.]/g,'')" :max="maxPayMoney" :disabled='isPage'></el-input>
            <span v-if="orderType == 'doubleOrder'">{{ $t('purchasing.procurementAgentBalance') }}：{{ procureVoucherAccount || 0 }}{{ $crmCurrencySuffix() }}</span>
            <span v-else>{{ $t('purchasing.accountBalance') }}：{{ agentAccountObj.voucherAccount || 0 }}{{ $crmCurrencySuffix() }}</span>
            <span>{{ $t('purchasing.maxDeductible') }}：{{ maxPayMoney || 0 }}</span>
          </el-form-item>
          <el-form-item :label="$t('purchasing.goldAccount')">
            <el-input v-model="formLabelAlign.totalGoldPayMoney" @blur="countInputNum(4)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>{{
              orderType == "doubleOrder" ? this.$t('purchasing.relatedAgentAccountBalance') : this.$t('purchasing.accountBalance')
            }}：{{ agentAccountObj.goldAccount || 0 }}</span>
            <span>{{ $t('purchasing.availableAmount') }}：{{ agentAccountObj.halfGoldAmount || 0 }}</span>
          </el-form-item>
          <el-form-item :label="$t('purchasing.cashAccount')">
            <el-input v-model="formLabelAlign.accountPayMoney" @blur="countInputNum(2)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>{{
              orderType == "doubleOrder" ? this.$t('purchasing.relatedAgentAccountBalance') : this.$t('purchasing.accountBalance')
            }}：{{ agentAccountObj.account || 0 }}</span>
          </el-form-item>
          <el-form-item v-if="orderType != 'doubleOrder'" :label="$t('purchasing.deliveryVoucherAccount')">
            <el-input v-model="formLabelAlign.deliveryMoney" @blur="countInputNum(5)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>{{ $t('purchasing.accountBalance') }}：{{ agentAccountObj.deliveryAccount || 0 }}</span>
          </el-form-item>
          <el-form-item v-if="orderType != 'doubleOrder'" :label="$t('purchasing.otherAmount')">
            <el-input v-model="formLabelAlign.elsePayMoney"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottom" v-if="bottomShow">{{ $t('purchasing.paymentMethod') }}<div @click="choicePayWay('mixue_alipay_code')" class="payway-item">
          <img src="@/assets/images/procure2Pay/zhifubao2.png" alt="" />
          <div v-if="payType == 'mixue_alipay_code'" class="is-choice-payway"></div>
        </div>
        <div @click="choicePayWay('mixue_wechat_code')" class="payway-item">
          <img src="@/assets/images/procure2Pay/weixinzhifu1.png" alt="" />
          <div v-if="payType == 'mixue_wechat_code'" class="is-choice-payway"></div>
        </div>
        <div @click="choicePayWay('bank')" class="payway-item">
          <img class="yin" src="@/assets/images/procure2Pay/transfer.jpg" alt="" />
          <span>{{ $t('purchasing.corporateTransfer') }}</span>
          <div v-if="payType == 'bank'" class="is-choice-payway"></div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelPay">{{ $t('app.auto_576_be030eaf') }}</el-button>
      <el-button type="primary" @click="Procure2PayFn">{{ $t('purchasing.pay') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  queryAgentAccount,
  queryDualAgentAccount,
  queryMaxVoucherPrice,
  queryMaxCreditVoucherPrice,
  queryDualMaxVoucherPrice,
  queryOrderPayInfo
} from "@/api/AccountInterface";
export default {
  data() {
    return {
      formLabelAlign: {
        voucherAccountPayMoney: 0.0,
        totalGoldPayMoney: 0.0,
        accountPayMoney: 0.0,
        deliveryMoney: 0.0,
        elsePayMoney: 0.0
      },
      maxPayMoney: 0,
      agentAccountObj: {},
      payType: "", // 选中的支付方式
      account: 0,
      payWay: 6070001,
      maxPayMoney: 0, //裂变账户最大可支付数
      voucherAccountPayMoney: 0, //裂变账户付款数
      accountPayMoney: 0, //代理商账户付款数
      elsePayMoney: 0, //剩余需要付款数
      deliveryMoney: 0,
      deliveryAccount: 0,
      totalGoldPayMoney: 0,
      totalGoldAccount: 0,
      halfGoldAmount: 0,
      goldAccount: 0,
      procureVoucherAccount: 0,
      isDialogVisiblePay: false,
    };
  },
  props: {
    isPage:{
      type: Boolean,
      default: true
    },
    payData: {
      type: Object,
      default: {}
    },
    orderId: {
      type: Number | String,
      default: ""
    },
    dialogVisiblePay: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: String,
      default: ""
    },
    bottomShow: {
      default: true
    }
  },
  watch: {
    orderId: {
      handler(newVal, oldVal) {
        this.selectData();
      }
    },
    dialogVisiblePay: {
      handler(newVal, oldVal) {
        console.log("xxx-1", newVal, oldVal);
        this.isDialogVisiblePay = newVal;
      },
      immediate: true
    }
  },
  methods: {
    // 支付
    Procure2PayFn() {
      if (this.formLabelAlign.elsePayMoney > 0 && !this.payType) {
        // 需要支付金额的
        this.$message.error(this.$t('purchasing.pleaseSelectPaymentMethod'));
      } else if (this.formLabelAlign.elsePayMoney <= 0) {
        if (
          this.formLabelAlign.voucherAccountPayMoney ||
          this.formLabelAlign.accountPayMoney ||
          this.formLabelAlign.totalGoldPayMoney ||
          this.formLabelAlign.deliveryMoney
        ) {
          console.log("走合理111");
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj
          );
        } else {
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj,
            "submitAndAgentPay"
          );
        }
      } else if (
        this.payType == "bank" &&
        this.formLabelAlign.elsePayMoney > 0
      ) {
        // 对公转账
        console.log("bankRransferPay",this.formLabelAlign);
        this.$emit(
          "bankRransferPay",
          this.formLabelAlign,
          this.payType,
          this.agentAccountObj
        );
      } else {
        if (
          this.formLabelAlign.voucherAccountPayMoney ||
          this.formLabelAlign.accountPayMoney ||
          this.formLabelAlign.totalGoldPayMoney ||
          this.formLabelAlign.deliveryMoney
        ) {
          console.log("submitPay");
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj,
            "submitAndAgentPay"
          );
        } else {
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj,
            "onlyAgentPay"
          );
        }
      }
    },
    async selectData() {
      if (this.orderType == "doubleOrder") {
        // 双重订单
        await queryDualAgentAccount({ orderNo: this.payData.orderNo }).then(
          ret => {
            if (ret.code == 0) {
              this.agentAccountObj = ret.data;
              console.log("ret.data", ret.data);
              const {
                account,
                voucherAccount,
                maxVoucherPrice,
                halfGoldAmount,
                goldAccount,
                deliveryAccount
              } = ret.data;
              this.account = account || 0; //账户余额
              this.halfGoldAmount = halfGoldAmount;
              this.totalGoldAccount = halfGoldAmount;
              this.goldAccount = goldAccount;
              this.deliveryAccount = deliveryAccount;
              let maxPayMoney =
                voucherAccount > maxVoucherPrice
                  ? maxVoucherPrice
                  : voucherAccount;
              this.maxPayMoney = maxPayMoney;
            }
          }
        );
      } else {
        // 线上订单 、赊货订单
        await queryAgentAccount({ campusId: this.payData.campusId }).then(
          ret => {
            if (ret.code == 0) {
              this.agentAccountObj = ret.data;
              const {
                account,
                voucherAccount,
                maxVoucherPrice,
                halfGoldAmount,
                goldAccount,
                deliveryAccount
              } = ret.data;
              this.account = account || 0; //账户余额
              this.halfGoldAmount = halfGoldAmount;
              this.totalGoldAccount = halfGoldAmount;
              this.goldAccount = goldAccount;
              this.deliveryAccount = deliveryAccount;
            }
          }
        );
      }
      console.log("orderType", this.orderType);
      // 美版不使用裂变/Voucher Bonus 接口与抵扣额（与 FreightProcure2Pay 美版策略一致）
      if (this.$i18n.locale !== "en-US") {
        if (this.orderType == "online") {
          // 线上订单
          await queryMaxVoucherPrice({ orderNo: this.payData.orderNo }).then(
            ret => {
              if (ret.code === 0) {
                const { voucherAccount, maxVoucherPrice } = ret.data;
                let maxPayMoney =
                  voucherAccount > maxVoucherPrice
                    ? maxVoucherPrice
                    : voucherAccount;
                console.log("maxPayMoney", maxPayMoney);
                this.maxPayMoney = maxPayMoney;
                this.voucherList = ret.data;
                this.formLabelAlign.voucherAccountPayMoney =
                  ret.data.maxVoucherPrice;
              }
            }
          );
        } else if (this.orderType == "creditorders") {
          //  赊货订单
          await queryMaxCreditVoucherPrice({
            orderNo: this.payData.orderNo
          }).then(ret => {
            if (ret.code === 0) {
              const { voucherAccount, maxVoucherPrice } = ret.data;
              let maxPayMoney =
                voucherAccount > maxVoucherPrice
                  ? maxVoucherPrice
                  : voucherAccount;
              console.log("maxPayMoney", maxPayMoney);
              this.maxPayMoney = maxPayMoney;
              this.voucherList = ret.data;
              this.formLabelAlign.voucherAccountPayMoney =
                ret.data.maxVoucherPrice;
            }
          });
        } else if (this.orderType == "doubleOrder") {
          // 双重订单
          await queryDualMaxVoucherPrice({ orderNo: this.payData.orderNo }).then(
            ret => {
              if (ret.code === 0) {
                const { voucherAccount, maxVoucherPrice } = ret.data;
                let maxPayMoney =
                  voucherAccount > maxVoucherPrice
                    ? maxVoucherPrice
                    : voucherAccount;
                console.log("maxPayMoney", maxPayMoney);
                this.maxPayMoney = maxPayMoney;
                this.voucherList = ret.data;
                this.procureVoucherAccount = voucherAccount;
                this.formLabelAlign.voucherAccountPayMoney =
                  ret.data.maxVoucherPrice;
              }
            }
          );
        }
      } else {
        this.maxPayMoney = 0;
        this.formLabelAlign.voucherAccountPayMoney = 0;
      }

      this.countInputNum();
    },
    countInputNum(type) {
      // voucherAccountPayMoney1   裂变  accountPayMoney  现金账户  totalGoldPayMoney1 金账户  elsePayMoney1 //剩余金额  receivedAmount  //实付金额  orderAmount //订单金额
      // orderAmount 采购金额
      // account 剩余帐户余额
      // receivedAmount 实付金额
      const { account, maxPayMoney, totalGoldAccount, deliveryAccount } = this;
      const {
        voucherAccountPayMoney,
        accountPayMoney,
        elsePayMoney,
        totalGoldPayMoney,
        deliveryMoney
      } = this.formLabelAlign;
      const { orderAmount, receivedAmount } = this.payData;
      let voucherAccountPayMoney1,
        accountPayMoney1,
        elsePayMoney1,
        totalGoldPayMoney1,
        deliveryMoney1;
      if (type == 1) {
        // 裂变奖金账户
         console.log("11111");
        voucherAccountPayMoney1 =
          (voucherAccountPayMoney > maxPayMoney
            ? maxPayMoney * 100
            : voucherAccountPayMoney * 100) / 100; //1account
        totalGoldPayMoney1 =
          (orderAmount * 100 -
            (receivedAmount * 100 + voucherAccountPayMoney * 100)) /
            100 >
            totalGoldAccount
            ? totalGoldAccount
            : (orderAmount * 100 -
              (receivedAmount * 100 + voucherAccountPayMoney1 * 100)) /
            100;
        accountPayMoney1 =
          account >
            (orderAmount * 100 -
              receivedAmount * 100 -
              voucherAccountPayMoney1 * 100 -
              totalGoldAccount * 100) /
            100
            ? (orderAmount * 100 -
              receivedAmount * 100 -
              voucherAccountPayMoney * 100 -
              totalGoldAccount * 100) /
            100
            : account;
            if (this.orderType != 'doubleOrder') {
              deliveryMoney1 =
                (orderAmount * 100 -
                  (receivedAmount * 100 +
                    voucherAccountPayMoney * 100 +
                    totalGoldAccount * 100 +
                    accountPayMoney * 100)) /
                  100 >
                  deliveryAccount
                  ? deliveryAccount
                  : (orderAmount * 100 -
                    (receivedAmount * 100 +
                      voucherAccountPayMoney1 * 100 +
                      totalGoldAccount * 100 +
                      accountPayMoney * 100)) /
                  100;
            } else {
              deliveryMoney1 = 0;
            }
        elsePayMoney1 =
          (orderAmount * 100 -
            (receivedAmount * 100 +
              (accountPayMoney1 > 0 ? accountPayMoney1 : 0) * 100 +
              (voucherAccountPayMoney1 > 0 ? voucherAccountPayMoney1 : 0) *
              100 +
              (totalGoldPayMoney1 > 0 ? totalGoldPayMoney1 : 0) * 100 +
              (deliveryMoney1 > 0 ? deliveryMoney1 : 0) * 100)) /
          100;
      } else if (type == 2) {
        // 现金账户
        console.log("2222");
        voucherAccountPayMoney1 = (voucherAccountPayMoney * 100) / 100;
        totalGoldPayMoney1 = (totalGoldPayMoney * 100) / 100;
        accountPayMoney1 =
          (accountPayMoney * 100 >
            orderAmount * 100 -
            receivedAmount * 100 -
            voucherAccountPayMoney * 100 -
            totalGoldPayMoney * 100 -
            deliveryMoney * 100
            ? orderAmount * 100 -
            receivedAmount * 100 -
            voucherAccountPayMoney * 100 -
            totalGoldPayMoney * 100 -
            deliveryMoney * 100
            : accountPayMoney * 100) / 100;
        if (this.orderType != 'doubleOrder') {
          deliveryMoney1 =
            (orderAmount * 100 -
              (receivedAmount * 100 +
                accountPayMoney * 100 +
                voucherAccountPayMoney * 100 +
                totalGoldPayMoney * 100 +
                elsePayMoney * 100) >
              deliveryAccount * 100
              ? deliveryAccount * 100
              : orderAmount * 100 -
              (receivedAmount * 100 +
                accountPayMoney * 100 +
                voucherAccountPayMoney * 100 +
                totalGoldPayMoney * 100 +
                elsePayMoney * 100)) / 100;
        } else {
          deliveryMoney1 = 0;
        }
        elsePayMoney1 =
          (orderAmount * 100 -
            (receivedAmount * 100 +
              accountPayMoney * 100 +
              voucherAccountPayMoney * 100 +
              totalGoldPayMoney * 100 +
              deliveryMoney1 * 100)) /
          100;
      } else if (type == 3) {
        // 剩余支付金额
        console.log("333333333333");
        totalGoldPayMoney1 = totalGoldPayMoney;
        voucherAccountPayMoney1 = (voucherAccountPayMoney * 100) / 100;
        accountPayMoney1 = (accountPayMoney * 100) / 100;
        elsePayMoney1 = (elsePayMoney * 100) / 100;
        if (this.orderType != 'doubleOrder') {
          deliveryMoney1 = (deliveryMoney * 100) / 100;
        } else {
          deliveryMoney1 = 0;
        }
      } else if (type == 4) {
        // 金账户
        console.log("444444-4");
        voucherAccountPayMoney1 = (voucherAccountPayMoney * 100) / 100;
        totalGoldPayMoney1 =
          totalGoldPayMoney <
            orderAmount - receivedAmount - voucherAccountPayMoney - deliveryMoney
            ? (totalGoldPayMoney * 100) / 100
            : (orderAmount * 100 -
              receivedAmount * 100 -
              voucherAccountPayMoney * 100 -
              deliveryMoney * 100) /
            100;
        accountPayMoney1 =
          account * 100 >
            orderAmount * 100 -
            (receivedAmount * 100 +
              voucherAccountPayMoney * 100 +
              totalGoldPayMoney * 100)
            ? (orderAmount * 100 -
              (receivedAmount * 100 +
                voucherAccountPayMoney * 100 +
                totalGoldPayMoney * 100)) /
            100
            : account;
            if (this.orderType != 'doubleOrder') {
              deliveryMoney1 =
                deliveryAccount * 100 >
                  orderAmount * 100 -
                  (receivedAmount * 100 +
                    voucherAccountPayMoney * 100 +
                    totalGoldPayMoney * 100 +
                    accountPayMoney1 * 100)
                  ? (orderAmount * 100 -
                    (receivedAmount * 100 +
                      voucherAccountPayMoney * 100 +
                      totalGoldPayMoney * 100 +
                      accountPayMoney1 * 100)) /
                  100
                  : deliveryAccount;
            } else {
              deliveryMoney1 = 0;
            }
        elsePayMoney1 =
          (orderAmount * 100 -
            (receivedAmount * 100 +
              accountPayMoney1 * 100 +
              voucherAccountPayMoney1 * 100 +
              totalGoldPayMoney * 100 +
              deliveryMoney1 * 100)) /
          100;
      } else if (type == 5) {
        // 提货券
        console.log("555555");
        voucherAccountPayMoney1 = (voucherAccountPayMoney * 100) / 100;
        totalGoldPayMoney1 =
          totalGoldPayMoney <
            orderAmount - receivedAmount - voucherAccountPayMoney - deliveryMoney
            ? (totalGoldPayMoney * 100) / 100
            : (orderAmount * 100 -
              receivedAmount * 100 -
              voucherAccountPayMoney * 100 -
              deliveryMoney * 100) /
            100;
        accountPayMoney1 =
          accountPayMoney <
            orderAmount - receivedAmount - voucherAccountPayMoney - deliveryMoney
            ? (accountPayMoney * 100) / 100
            : (orderAmount * 100 -
              receivedAmount * 100 -
              voucherAccountPayMoney * 100 -
              deliveryMoney * 100) /
            100;

        if (totalGoldPayMoney1 < 0) {
          totalGoldPayMoney1 = 0;
        }
        if (accountPayMoney1 < 0) {
          accountPayMoney1 = 0;
        }

        if (this.orderType != 'doubleOrder') {
          deliveryMoney1 =
            deliveryMoney <
              orderAmount -
              receivedAmount -
              voucherAccountPayMoney -
              accountPayMoney
              ? (deliveryMoney * 100) / 100
              : (orderAmount * 100 -
                receivedAmount * 100 -
                voucherAccountPayMoney * 100 -
                accountPayMoney1 * 100) /
              100;
        } else {
          deliveryMoney1 = 0;
        }
        
        if (
          receivedAmount * 100 +
          accountPayMoney1 * 100 +
          voucherAccountPayMoney1 * 100 +
          totalGoldPayMoney * 100 +
          deliveryMoney * 100 >
          orderAmount * 100
        ) {
          elsePayMoney1 = 0 * 100;
        } else {
          elsePayMoney1 =
            (orderAmount * 100 -
              (receivedAmount * 100 +
                accountPayMoney1 * 100 +
                voucherAccountPayMoney1 * 100 +
                totalGoldPayMoney * 100 +
                deliveryMoney1 * 100)) /
            100;
        }
      } else {
        console.log("nulllllll");
        console.log(maxPayMoney, orderAmount, receivedAmount);
        voucherAccountPayMoney1 =
          (maxPayMoney > orderAmount - receivedAmount
            ? orderAmount * 100 - receivedAmount * 100
            : maxPayMoney * 100) / 100;
        totalGoldPayMoney1 =
          (orderAmount * 100 -
            (receivedAmount * 100 + voucherAccountPayMoney1 * 100)) /
            100 >
            totalGoldAccount
            ? totalGoldAccount
            : (orderAmount * 100 -
              (receivedAmount * 100 + voucherAccountPayMoney1 * 100)) /
              100 <
              0
              ? 0
              : (orderAmount * 100 -
                (receivedAmount * 100 + voucherAccountPayMoney1 * 100)) /
              100;
        accountPayMoney1 =
          (account * 100 -
            (orderAmount * 100 -
              (receivedAmount * 100 +
                voucherAccountPayMoney1 * 100 +
                totalGoldPayMoney1 * 100 +
                deliveryMoney * 100)) >=
            0
            ? orderAmount * 100 -
              (receivedAmount * 100 +
                voucherAccountPayMoney1 * 100 +
                totalGoldPayMoney1 * 100 +
                deliveryMoney * 100) <=
              0
              ? 0
              : orderAmount * 100 -
              (receivedAmount * 100 +
                voucherAccountPayMoney1 * 100 +
                totalGoldPayMoney1 * 100 +
                deliveryMoney * 100)
            : account * 100) / 100;
          if (this.orderType != 'doubleOrder') {
            deliveryMoney1 =
            (orderAmount * 100 -
              (receivedAmount * 100 +
                accountPayMoney1 * 100 +
                voucherAccountPayMoney1 * 100 +
                totalGoldPayMoney1 * 100 +
                elsePayMoney * 100) >
              deliveryAccount * 100
              ? deliveryAccount * 100
              : orderAmount * 100 -
              (receivedAmount * 100 +
                accountPayMoney1 * 100 +
                voucherAccountPayMoney1 * 100 +
                totalGoldPayMoney1 * 100 +
                elsePayMoney * 100)) / 100;
          } else {
            deliveryMoney1 = 0;
          }
        elsePayMoney1 =
          (orderAmount * 100 -
            (receivedAmount * 100 +
              accountPayMoney1 * 100 +
              voucherAccountPayMoney1 * 100 +
              totalGoldPayMoney1 * 100 +
              deliveryMoney1 * 100)) /
          100;
      }
      // voucherAccountPayMoney1   裂变  accountPayMoney  现金账户  totalGoldPayMoney1 金账户  elsePayMoney1 //剩余金额  receivedAmount  //实付金额  orderAmount //订单金额
      this.formLabelAlign.voucherAccountPayMoney =
        voucherAccountPayMoney1 > 0 ? voucherAccountPayMoney1.toFixed(2) : 0;
      this.formLabelAlign.accountPayMoney =
        accountPayMoney1 > 0 ? accountPayMoney1.toFixed(2) : 0;
      this.formLabelAlign.elsePayMoney =
        elsePayMoney1 > 0 ? elsePayMoney1.toFixed(2) : 0;
      this.formLabelAlign.totalGoldPayMoney =
        totalGoldPayMoney1 > 0 ? totalGoldPayMoney1.toFixed(2) : 0;
        if((Number(this.formLabelAlign.voucherAccountPayMoney) + Number(this.formLabelAlign.accountPayMoney)) >= orderAmount){
           this.formLabelAlign.deliveryMoney = 0
        }else{
            this.formLabelAlign.deliveryMoney =
            deliveryMoney1 > 0 ? deliveryMoney1.toFixed(2) : 0;
        }
    },
    // 选中支付方式
    choicePayWay(way) {
      this.payType = way;
    },
    // 取消支付
    cancelPay() {
      // if (this.formLabelAlign.voucherAccountPayMoney || this.formLabelAlign.accountPayMoney || this.formLabelAlign.totalGoldPayMoney || this.formLabelAlign.deliveryMoney) {
      //   this.$emit('submitPay', this.formLabelAlign, this.payType, this.agentAccountObj, 'paymentFN');
      // } else {
      //   this.$emit('cancelSubitPay');
      // }
      this.$emit("cancelSubitPay");
    },
    closeProcure2Pay() {
      console.log("111xxxdsds--1");
      this.isDialogVisiblePay = false;
      this.$emit("closeProcure2Pay");
    }
  },
  mounted() {
    this.selectData();
  }
};
</script>

<style lang="scss" scoped>
.purchase-info {
  color: #1890ff;
  background: rgb(232, 243, 254);
  width: 95%;
  // height: 80px;
  margin: 0 auto;
  border-radius: 10px;
  font-size: 14px;
  padding: 10px;
  overflow: hidden;
  margin-bottom: 20px;

  .textOne {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .textTwo {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.pay-box {
  margin-left: 20px;

  .el-input {
    text-align: left;
    width: 40%;
    margin-right: 8%;
  }

  &.pay-box-en .el-input {
    width: 30%;
  }

  span {
    margin-right: 3%;
  }
}

.bottom {
  margin-left: 40px;
  display: flex;

  .payway-item {
    position: relative;
    width: 145px;
    height: 52px;
    border: 1px solid rgb(103, 99, 99);
    margin: 0 20px;
    border-radius: 5px;
    line-height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 117px;
      height: 40px;
    }

    .yin {
      width: 54px;
      height: 34px;
    }

    &:hover {
      cursor: pointer;
    }

    .is-choice-payway {
      position: absolute;
      width: 23px;
      height: 23px;
      background: url("@/assets/images/procure2Pay/cornerMark.png") no-repeat;
      right: 0;
      bottom: 0;
      background-size: 100% 100%;
    }
  }
}

:deep(.el-dialog__footer) {
  border-top: 1px solid #e8e8e8;
  padding: 10px;
}
</style>
